import React, { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import { getTenantBranding } from "../config.js";

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isStandalone, setIsStandalone] = useState(false);
  const [showIosHelp, setShowIosHelp] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    setIsStandalone(standalone);

    const onBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };

    window.addEventListener("beforeinstallprompt", onBeforeInstallPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onBeforeInstallPrompt);
  }, []);

  if (isStandalone) return null;

  const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
  const appName = getTenantBranding().appName;

  const install = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      setDeferredPrompt(null);
      return;
    }

    if (isIos) {
      setShowIosHelp(true);
    }
  };

  if (!deferredPrompt && !isIos) return null;

  return (
    <div className="pwa-install-bar">
      <div>
        <strong>Instale o {appName}</strong>
        <span> para acessar o atendimento pela tela inicial do celular.</span>
        {showIosHelp && (
          <div className="pwa-ios-help">
            No iPhone/iPad: toque em <strong>Compartilhar</strong> e depois em
            <strong> Adicionar à Tela de Início</strong>.
          </div>
        )}
      </div>
      <Button color="primary" variant="outlined" onClick={install}>
        Instalar
      </Button>
    </div>
  );
}
